const ensureCounterDefaults = (changedObject, position) => {
  if (!changedObject) {
    return {};
  }

  if (!changedObject.counter_id_data) {
    changedObject.counter_id_data = [];
  }

  if (!changedObject.counter_id_data[position]) {
    changedObject.counter_id_data[position] = {};
  }

  const counter = changedObject.counter_id_data[position];

  if (
    !Object.prototype.hasOwnProperty.call(
      counter,
      'two_way_measurement_built_in'
    )
  ) {
    counter.two_way_measurement_built_in = false;
  }
  if (!Object.prototype.hasOwnProperty.call(counter, 'ehz_required')) {
    counter.ehz_required = false;
  }

  return counter;
};

const normalizeCounterIdData = (counterIdData) => {
  if (!Array.isArray(counterIdData)) {
    return counterIdData;
  }

  return counterIdData.map((counter = {}) => ({
    ...counter,
    two_way_measurement_built_in: counter.two_way_measurement_built_in ?? false,
    ehz_required: counter.ehz_required ?? false,
  }));
};

export const feedInSystemsCounterModule = {
  state: { is_counter_available: null },
  getters: {
    getIsCounterAvailable: ({ is_counter_available }) => is_counter_available,
    getCounterNumberByPosition: (state, getters, rootState) => (position) => {
      if (!Array.isArray(rootState.changed_object.counter_id_data)) {
        return null;
      }
      return (
        rootState.changed_object.counter_id_data[position]?.counter_id || null
      );
    },
    getCounterFileNameByPosition: (state, getters, rootState) => (position) => {
      if (!Array.isArray(rootState.changed_object.counter_id_data)) {
        return null;
      }
      return (
        rootState.changed_object.counter_id_data[position]?.file_name || null
      );
    },
    getIsTwoWayMeasurementByCounterPosition:
      (state, getters, rootState) => (position) => {
        if (!Array.isArray(rootState.changed_object.counter_id_data)) {
          return null;
        }
        return (
          rootState.changed_object.counter_id_data[position]
            ?.two_way_measurement_built_in ?? false
        );
      },
    getEhzRequiredByCounterPosition:
      (state, getters, rootState) => (position) => {
        if (!Array.isArray(rootState.changed_object.counter_id_data)) {
          return null;
        }
        return (
          rootState.changed_object.counter_id_data[position]?.ehz_required ??
          false
        );
      },
    getMsbProviderByCounterPosition:
      (state, getters, rootState) => (position) => {
        if (!Array.isArray(rootState.changed_object.counter_id_data)) {
          return null;
        }
        return (
          rootState.changed_object.counter_id_data[position]?.msb_provider ||
          null
        );
      },
    getCounterIdToRemove: (state, getters, rootState) => {
      return rootState.changed_object.counter_id_to_remove || null;
    },
    getSimultaneousPower(state, getters, rootState) {
      return (
        rootState.changed_object.new_counter_data?.simultaneous_power_w || null
      );
    },
    getConsumptionProspect(state, getters, rootState) {
      return (
        rootState.changed_object.new_counter_data?.consumption_prospect_wh ||
        null
      );
    },
    getCommissioningApplicationFileName(state, getters, rootState) {
      return (
        rootState.changed_object.new_counter_data
          ?.commissioning_application_file_name || null
      );
    },
  },

  mutations: {
    setIsCounterAvailable(state, value) {
      state.is_counter_available = value;
      if (value === false) {
        this.state.changed_object.counter_id_data = null;
        this.state.changed_object.new_counter_data = {
          simultaneous_power_w: null,
          consumption_prospect_wh: null,
          commissioning_application_file_name: null,
        };
        this.state.changed_object.counters_to_remove_data = null;
      }
      if (value === true) {
        const originalCounterIdData =
          this.state.feedInSystems.selectedFeedInSystem.counter_id_data;
        this.state.changed_object.new_counter_data = null;
        this.state.changed_object.counter_id_data = normalizeCounterIdData(
          originalCounterIdData
        );
        this.state.changed_object.counters_to_remove_data =
          this.state.feedInSystems.selectedFeedInSystem.counters_to_remove_data;
      }
    },
    setCounterNumber(state, object) {
      const counter = ensureCounterDefaults(
        this.state.changed_object,
        object.position
      );
      counter.counter_id = object.value;
    },

    setCounterFileName(state, object) {
      const counter = ensureCounterDefaults(
        this.state.changed_object,
        object.position
      );

      counter.file_name = object.value;
    },

    setIsTwoWayMeasurementByCounterPosition(state, object) {
      const counter = ensureCounterDefaults(
        this.state.changed_object,
        object.position
      );

      counter.two_way_measurement_built_in = object.value;
    },
    setEhzRequiredByCounterPosition(state, object) {
      const counter = ensureCounterDefaults(
        this.state.changed_object,
        object.position
      );

      counter.ehz_required = object.value;
    },
    setMsbProviderByCounterPosition(state, object) {
      const counter = ensureCounterDefaults(
        this.state.changed_object,
        object.position
      );

      counter.msb_provider = object.value;
    },
    setCounterIdToRemove(state, value) {
      this.state.changed_object.counter_id_to_remove = value;
    },
    setSimultaneousPower(state, value) {
      this.state.changed_object.new_counter_data.simultaneous_power_w =
        Math.round(value);
    },

    setConsumptionProspect(state, value) {
      this.state.changed_object.new_counter_data.consumption_prospect_wh =
        Math.round(value);
    },

    setCommissioningApplicationFileName(state, value) {
      this.state.changed_object.new_counter_data.commissioning_application_file_name =
        value;
    },
  },
};
